function OverlayHeader(props) {
	return (
		<header
			className={`page-head ${props.transparent ? 'u-bg-trans' : ''} ${props.className}`}
			ref={props.headerElement}
		>
			{props.children}
		</header>
	);
}

export default OverlayHeader;
